export const newsList = [
  {
    title: '모든 헌혈자가 사용하는 그날까지"…피와 사람을 잇는 "피플"',
    link: 'https://www.yna.co.kr/view/AKR20231108166000004',
    newsPaper: '연합뉴스',
  },
  {
    title: '헌혈로 4000명 생명 살림 "피플", 보건복지형 예비사회적기업에',
    link: 'https://www.viva100.com/main/view.php?key=20231101010000066',
    newsPaper: '브릿지경제',
  },
  {
    title: `브라이언임팩트재단, 피플 등 기술로 세상 바꾸는 10개 혁신기업 지원`,
    link: 'https://www.hankookilbo.com/News/Read/A2023101614430000064?did=NA',
    newsPaper: '한국일보',
  },
  {
    title: `제1회 헌혈의 밤 개최, "헌혈 인식 개선해야…`,
    link: 'https://n.news.naver.com/article/346/0000064104?sid=103',
    newsPaper: '헬스조선',
  },
  {
    title: `700건의 사연, 2000건의 헌혈 응답…"생명을 잇는 피플"`,
    link: 'https://www.news1.kr/articles/?4612911',
    newsPaper: '뉴스1',
  },
  {
    title: `백혈병 14개월 아기 살렸다…가족은 아니지만 '피를 나눈' 천사들`,
    link: 'https://news.mt.co.kr/mtview.php?no=2022030609314445683',
    newsPaper: '머니투데이',
  },
  {
    title: `혈액 사각지대에 있는 이들 위해 ‘붉은 인연’ 만들고 싶었어요`,
    link: 'https://www.hankookilbo.com/News/Read/202002161445352382',
    newsPaper: '한국일보',
  },
];
